import React, { useEffect, useState } from 'react';
import { Button } from './ui';
import { Clock, Footprints } from 'lucide-react';
const CHECKOUT_URL = 'https://running-desde-cero.impultienda.ar/checkout';
export function Pricing() {
  const [timeLeft, setTimeLeft] = useState({
    h: 23,
    m: 59,
    s: 52
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.s > 0) return {
          ...prev,
          s: prev.s - 1
        };
        if (prev.m > 0) return {
          ...prev,
          m: prev.m - 1,
          s: 59
        };
        if (prev.h > 0) return {
          h: prev.h - 1,
          m: 59,
          s: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <section className="py-12 px-4 bg-slate-950 relative" data-id="element-148" data-mp="gn22nf5rapjo">
      <div className="absolute inset-0 bg-brand-900/10 pointer-events-none" data-id="element-149" data-mp="lj0kejwkx9b4" />

      <div className="payment-block max-w-5xl mx-auto relative z-10" id="bloque-pago" data-id="element-150" data-mp="qjomq1q9dckn">
        <div className="text-center mb-5" data-id="element-151" data-mp="ujytvhpse913">
          <div className="inline-flex items-center gap-2.5 bg-red-500/15 text-red-400 border border-red-500/40 px-5 py-2.5 rounded-full font-bold mb-3 text-sm sm:text-base shadow-[0_0_20px_rgba(239,68,68,0.25)]" data-id="element-152" data-mp="uinojdgp0t7v">
            <Clock className="w-5 h-5 shrink-0 animate-pulse" data-id="element-153" data-mp="1f4n1ediaqn7c" />
            <span data-id="element-154" data-mp="1a3pmqawhwbal">PRECIO DE LANZAMIENTO — CIERRA EN:</span>
            <span className="tabular-nums text-white text-base sm:text-lg font-black tracking-wide" data-id="element-155" data-mp="154mg4m0v9x0i">
              {String(timeLeft.h).padStart(2, '0')}:{String(timeLeft.m).padStart(2, '0')}:{String(timeLeft.s).padStart(2, '0')}
            </span>
          </div>
          <p className="text-brand-400 font-medium text-sm flex items-center justify-center gap-2" data-id="element-156" data-mp="1xuv08jeyqrhq">⚠️ Después sube $5.000 ARS. No vuelve.</p>
          <div className="w-full max-w-md mx-auto mt-3 bg-slate-800 rounded-full h-1.5 overflow-hidden" data-id="element-157" data-mp="1o3iabxcq6bec"><div className="bg-brand-500 h-full w-[72%]" data-id="element-158" data-mp="2liw4vh90tnrv" /></div>
          <p className="text-[11px] text-slate-500 mt-1.5" data-id="element-159" data-mp="2lkfnhei5gawt">72% de los cupos al precio de lanzamiento ya tomados</p>
        </div>

        <h2 className="text-2xl md:text-4xl font-bold text-center text-white mb-5" data-id="element-160" data-mp="eucbaeqg8kwn">EMPEZÁ TU CAMINO A LOS 5K</h2>

        <div className="flex flex-col gap-3 max-w-2xl mx-auto" role="radiogroup" aria-label="Elegí el Megapack Running Desde Cero" data-id="element-161" data-mp="jtoy4zhblrz8">
          <button type="button" role="radio" aria-checked={true} className="relative w-full text-left rounded-2xl border p-4 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:ring-offset-2 focus:ring-offset-slate-950 border-brand-500 bg-brand-900/15 shadow-[0_0_20px_rgba(37,99,235,0.25)]" data-id="element-162" data-mp="53rduumihmfb">
            <div className="flex items-start gap-3" data-id="element-163" data-mp="3ic47k5bmbr0n">
              <span className="mt-0.5 shrink-0 w-5 h-5 rounded-full border-2 flex items-center justify-center transition-colors border-brand-400 bg-brand-500" aria-hidden="true" data-id="element-164" data-mp="3n9w113rwvl6y"><span className="w-2 h-2 rounded-full bg-white" data-id="element-165" data-mp="1gk8zdzokm4n6" /></span>
              <div className="min-w-0 flex-1" data-id="element-166" data-mp="1lhhiq3lggeq0">
                <h3 className="font-bold text-white text-base flex items-center gap-2 leading-tight" data-id="element-167" data-mp="1lg6haafhfj22">
                  <span className="shrink-0" data-id="element-168" data-mp="35y8ivxtwtfm8"><Footprints className="w-6 h-6 text-brand-400" data-id="element-169" data-mp="3120b55i1kop3" /></span>
                  <span className="truncate" data-id="element-170" data-mp="30znmyaloxi3l">RUNNING DESDE CERO™ — MEGAPACK</span>
                </h3>
                <p className="text-brand-400 text-xs font-medium mt-0.5" data-id="element-171" data-mp="3azo7fzvaq49d">6 Tomos + 5 Bonos</p>
                <p className="text-slate-400 text-xs mt-1.5 leading-snug" data-id="element-172" data-mp="3axtjsdsn3y1l"><span className="text-slate-500 font-medium" data-id="element-173" data-mp="3oprli3k0urnq">Ideal para: </span>Personas que quieren pasar de cero a sus primeros 5 kilómetros con un plan claro y seguro</p>
                <p className="text-[11px] font-medium mt-1.5 text-brand-400" data-id="element-174" data-mp="2ke64tz8d32n">Precio de lanzamiento</p>
              </div>
              <div className="shrink-0 text-right pl-1" data-id="element-175" data-mp="3trh0fuad7ph3">
                <p className="text-slate-500 line-through text-xs leading-none mb-1" data-id="element-176" data-mp="24b7pztg946gg">$49.000</p>
                <p className="text-2xl sm:text-3xl font-black text-white leading-none" data-id="element-177" data-mp="1zc4p8l7b0mea">$19.990</p>
                <p className="text-[10px] text-slate-400 mt-0.5" data-id="element-178" data-mp="qf6gfswrov0r">ARS</p>
              </div>
            </div>
          </button>
        </div>

        <div className="max-w-2xl mx-auto mt-5" data-id="element-179" data-mp="vd828llkv8fx">
          <Button className="w-full text-base py-4 shadow-[0_0_20px_rgba(37,99,235,0.4)]" onClick={() => {
          window.location.href = CHECKOUT_URL;
        }} data-id="element-180" data-mp="vg3ze7plpt3b">
            → QUIERO EMPEZAR A CORRER HOY
          </Button>
          <p className="text-center text-xs text-slate-500 mt-2" data-id="element-181" data-mp="7ooty62j2vnu">Garantía 7 días · Pago seguro · Acceso inmediato</p>
        </div>
      </div>
    </section>;
}